export class KnowledgeOfLanguages {
  what_foreign_lang_learn: number = null;
  foreign_lang_degree: number = null;
  russian_lang_degree: number = null;
  kazakh_lang_degree: number = null;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/personal-achievements/KnowledgeOfLanguages.ts